// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MyBannerCarousel_carousel_container__6aF8N {
    width: 100%;
    height: 100%;
}

.MyBannerCarousel_carousel_container__6aF8N .slick-list {
    border-radius: 12px;
}

.MyBannerCarousel_carousel_container__6aF8N .slick-slide,
.MyBannerCarousel_carousel_container__6aF8N .slick-slide>div {
    width: 100% !important;
    height: 133px !important;
}

.MyBannerCarousel_carousel_item__eRIXA {
    width: 100%;
    height: 100%;
}

.MyBannerCarousel_carousel_item_bg_img__Z7UbO {
    width: 100%;
    height: 100%;
}`, "",{"version":3,"sources":["webpack://./src/common/MyBannerCarousel/index.module.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;;IAEI,sBAAsB;IACtB,wBAAwB;AAC5B;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB","sourcesContent":[".carousel_container {\n    width: 100%;\n    height: 100%;\n}\n\n.carousel_container :global(.slick-list) {\n    border-radius: 12px;\n}\n\n.carousel_container :global(.slick-slide),\n.carousel_container :global(.slick-slide>div) {\n    width: 100% !important;\n    height: 133px !important;\n}\n\n.carousel_item {\n    width: 100%;\n    height: 100%;\n}\n\n.carousel_item_bg_img {\n    width: 100%;\n    height: 100%;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"carousel_container": `MyBannerCarousel_carousel_container__6aF8N`,
	"carousel_item": `MyBannerCarousel_carousel_item__eRIXA`,
	"carousel_item_bg_img": `MyBannerCarousel_carousel_item_bg_img__Z7UbO`
};
export default ___CSS_LOADER_EXPORT___;
